import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-comment-form',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './comment-form.component.html',
  styleUrls: ['./comment-form.component.scss'],
})
export class CommentFormComponent implements AfterViewInit {
  @Input() isSubmitting = false;
  @Output() submitComment = new EventEmitter<string>();
  @Output() cancel = new EventEmitter<void>();
  @ViewChild('editor') editorElement!: ElementRef<HTMLDivElement>;

  private _isValid = false;

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.editorElement?.nativeElement.focus();
    }, 100);
  }

  onEditorInput(): void {
    const text = this.editorElement?.nativeElement?.innerText?.trim() || '';
    this._isValid = text.length > 0;
  }

  execCommand(command: string, value: string | undefined = undefined): void {
    document.execCommand(command, false, value);
    this.editorElement.nativeElement.focus();
    this.onEditorInput();
  }

  onSubmit(): void {
    if (this.isValid && !this.isSubmitting) {
      const content = this.editorElement.nativeElement.innerHTML;
      this.submitComment.emit(content);
    }
  }

  onCancel(): void {
    this.editorElement.nativeElement.innerHTML = '';
    this._isValid = false;
    this.cancel.emit();
  }

  get isValid(): boolean {
    return this._isValid;
  }
}
